export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export interface NavItem {
  label: string;
  href: string;
  isExternal?: boolean;
}

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export interface Stat {
  id: string;
  value: string;
  label: string;
  suffix?: string;
}